import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const HomeFilled = ({ width = 26, height = 26, fill = '#1D2225', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.75 20.5833V10.9999C5.75 10.6899 5.81933 10.3962 5.958 10.1189C6.09685 9.84136 6.2886 9.61287 6.53325 9.4334L12.7001 4.78752C13.0423 4.52644 13.4334 4.3959 13.8734 4.3959C14.3134 4.3959 14.7056 4.52644 15.0499 4.78752L21.2168 9.4334C21.4614 9.61287 21.6532 9.84136 21.792 10.1189C21.9307 10.3962 22 10.6899 22 10.9999V20.5833C22 21.0264 21.8399 21.408 21.5198 21.7281C21.1997 22.0483 20.8181 22.2083 20.375 22.2083H16.9167C16.6392 22.2083 16.4067 22.1144 16.2191 21.9267C16.0313 21.7391 15.9374 21.5065 15.9374 21.229V15.9375C15.9374 15.6601 15.8436 15.4276 15.656 15.2398C15.4684 15.0522 15.2358 14.9584 14.9583 14.9584H12.7917C12.5142 14.9584 12.2816 15.0522 12.094 15.2398C11.9064 15.4276 11.8126 15.6601 11.8126 15.9375V21.229C11.8126 21.5065 11.7187 21.7391 11.5309 21.9267C11.3433 22.1144 11.1108 22.2083 10.8333 22.2083H7.375C6.93192 22.2083 6.55031 22.0483 6.23019 21.7281C5.91006 21.408 5.75 21.0264 5.75 20.5833Z"
        fill={fill}
      />
    </Svg>
  );
};

export default HomeFilled;
